import { createFileRoute, useParams } from '@tanstack/react-router';

import { BusinessAssociateDetailScreen } from '@/features/business-associates/components/platform/BusinessAssociateDetailScreen';

export const Route = createFileRoute('/_staff/admin/platform/business-associates/$baId/')({
  component: BusinessAssociateDetailRoute,
});

function BusinessAssociateDetailRoute() {
  const { baId } = useParams({
    from: '/_staff/admin/platform/business-associates/$baId/',
  });
  return <BusinessAssociateDetailScreen baId={baId} />;
}
